import { Tab, useTabParams } from './tab-manager';
import { TabItem } from './components/topbar/tab-item';
import React from 'react';
import { useInScopeModel } from './actions/framework/use-in-scope-model';
import { GraphModel } from './graph/graph.model';
import { Assert } from '@cotera/utilities';
import { ReadonlyWatchable, useWatchableValue } from './actions/framework';
import _ from 'lodash';
import { Clipboard } from 'lucide-react';
import { toast } from '../app/components/ui/toaster';
import { Schedule } from '@cotera/api';

export const IdentitesPage: React.FC = () => {
  const { tabId } = useTabParams<{ tabId: string }>();
  return (
    <>
      <Tab tabId={tabId}>
        <TabItem
          tab={{
            id: tabId,
            title: `Identities`,
            displayTitle: `Identities`,
            icon: 'finger-print',
            showClose: true,
          }}
        />
      </Tab>
      <Page />
    </>
  );
};

const Page: React.FC<{}> = () => {
  const model = useInScopeModel(GraphModel);
  Assert.assert(model !== null, 'Model not found');
  const idents = model.graph.map(({ nodeMap }) =>
    _.mapValues(nodeMap, (res) => ({
      identity: res.meta.identity.toString(),
      ...(res.t === 'rel'
        ? {
            cols: _.mapValues(res.cols, (x) => {
              const val: {
                identity: string;
                schedule?: Schedule;
                type: string;
              } = {
                identity: x.meta.identity.toString(),
                type: x.def.t,
              };

              return val;
            }),
          }
        : {}),
    }))
  );

  return (
    <div className="flex flex-col gap-4 h-full overflow-y-auto">
      <DisplayIdents idents={idents} />;
    </div>
  );
};

const DisplayIdents: React.FC<{
  idents: ReadonlyWatchable<
    Record<
      string,
      {
        identity: string;
        cols?: Record<
          string,
          { identity: string; schedule?: Schedule; type: string }
        >;
      }
    >
  >;
}> = ({ idents }) => {
  const json = JSON.stringify(useWatchableValue(idents), null, 2);
  return (
    <div>
      <Clipboard
        className="ml-auto h-6 w-6 text-gray-500 cursor-pointer mt-2"
        onClick={async () => {
          await navigator.clipboard.writeText(json);
          toast.info('Copied query to clipboard');
        }}
      />
      <pre className="bg-gray-800 text-gray-100 p-4 rounded-md overflow-x-auto my-4">
        {json}
      </pre>
    </div>
  );
};
